import IMG_1_1 from 'assets/images/scooter/viva/img-viva-kv.png'

import IMG_4_1 from 'assets/images/scooter/viva/img-video-placeholder.png'
import IMG_4_2 from 'assets/images/play.svg'

import IMG_5_1 from 'assets/images/scooter/viva/img-divider-experience-bg.png'
import IMG_5_2 from 'assets/images/scooter/viva/img-divider-experience-scooter.png'

import IMG_6_1 from 'assets/images/scooter/viva/img-experience-1.png'
import IMG_6_2 from 'assets/images/scooter/viva/img-experience-2.png'
import IMG_6_3 from 'assets/images/scooter/viva/img-experience-2_m.png'
import IMG_6_4 from 'assets/images/scooter/viva/img-experience-3.png'
import IMG_6_5 from 'assets/images/scooter/viva/img-experience-3_m.png'

import IMG_7_1 from 'assets/images/scooter/viva/back.png'
import IMG_7_2 from 'assets/images/scooter/viva/back_m.png'

import IMG_8_1 from 'assets/images/prev_arrow.svg'
import IMG_8_2 from 'assets/images/next_arrow.svg'

import IMG_9_1 from 'assets/images/scooter/viva/img-divider-design-bg.png'
import IMG_9_2 from 'assets/images/scooter/viva/img-divider-design-scooter.png'

import IMG_10_1 from 'assets/images/scooter/viva/img-design-1.png'
import IMG_10_2 from 'assets/images/scooter/viva/img-design-2.png'
import IMG_10_3 from 'assets/images/scooter/viva/img-design-3.png'
import IMG_10_4 from 'assets/images/scooter/viva/img-design-4.png'

import IMG_11_1 from 'assets/images/scooter/viva/img-divider-features-bg.png'
import IMG_11_2 from 'assets/images/scooter/viva/img-divider-features-scooter.png'

import IMG_12_1 from 'assets/images/scooter/viva/img-features-1.png'
import IMG_12_2 from 'assets/images/scooter/viva/20220523_183816.png'
import IMG_12_3 from 'assets/images/scooter/viva/20220523_183849.png'
import IMG_12_4 from 'assets/images/scooter/viva/img-features-2.png'

import IMG_13_1 from 'assets/images/scooter/viva/20220523_184838.png'
import IMG_13_2 from 'assets/images/scooter/viva/icon-gostation.png'

import IMG_14_1 from 'assets/images/scooter/viva/gogoro-network.png'

import IMG_15_1 from 'assets/images/scooter/viva/img-series-model-keyless.png'

import { URL, OUTER_URL } from '../../utils/Utils'
import ScooterVivaImgSwiper from '../../components/swiper/ScooterVivaImgSwiper'
import './ScooterViva.scss'

/**
 * 23.03.06 해당 화면 제거 요청
 * @file 고고로 2 VIVA 화면
 */
function ScooterViva() {
    return (
        <>
            <div className="viva-one" style={{ backgroundImage: `url(${IMG_1_1})` }} />
            <div className="viva-two">
                <div>
                    <div className="t1">고고로 비바</div>
                    <a className="link" href="" onClick={() => window.open(OUTER_URL.GOGORO_HOMPAGE)}>
                        차량문의
                    </a>
                </div>
            </div>
            <div className="viva-three">
                <div className="text">
                    초경량 스마트 스쿠터 <br />
                    Gogoro VIVA <br />
                    <br />
                    일상에서 도시를 탐험하고 <br />
                    소소한 행복을 누리세요.
                </div>
            </div>
            <div className="viva-four" style={{ backgroundImage: `url(${IMG_4_1})` }}>
                <a className="link" href={OUTER_URL.YOUTUBE_VIVA} target="_blank" rel="noopener noreferrer">
                    <img src={IMG_4_2} alt="" />
                    <div>전체 비디오 보기</div>
                </a>
            </div>
            <div className="viva-five" style={{ backgroundImage: `url(${IMG_5_1})` }}>
                <div className="img" style={{ backgroundImage: `url(${IMG_5_2})` }} />
                <div className="text-box">
                    <div className="sub">Ultra simplicity</div>
                    <div className="t1">
                        완벽한 크기, <br />
                        놀라운 승차감
                    </div>
                </div>
            </div>

            <div className="viva-six">
                <div className="t1">
                    원하는 곳 어디든 갈 수 있습니다. <br />
                    일상에 맞춘 완벽한 균형
                </div>
                <div className="grid-box">
                    <div>
                        <div className="one img">
                            <img src={IMG_6_1} alt="" />
                            <div className="text-box">
                                <div className="sub">Ultra simplicity</div>
                                <div className="t1">
                                    단순하지만 더욱더 든든하게. <br />
                                    어디든 걱정하지 마세요. <br />
                                    장소에 상관없이 누리는 자유
                                </div>
                            </div>
                        </div>
                    </div>
                    <div>
                        <div className="two img">
                            <img className="pc" src={IMG_6_2} alt="" />
                            <img className="mobile" src={IMG_6_3} alt="" />
                            <div className="text-box">
                                <div className="sub">Just right</div>
                                <div className="t1">
                                    콤팩트한 디자인은 <br />더 잘 움직이고 더 쉽게 <br />
                                    주차할 수 있습니다.
                                </div>
                            </div>
                        </div>
                    </div>
                    <div>
                        <div className="three img">
                            <img className="pc" src={IMG_6_4} alt="" />
                            <img className="mobile" src={IMG_6_5} alt="" />
                            <div className="text-box">
                                <div className="sub">Simple is the best</div>
                                <div className="t1">
                                    복잡함은 이제 그만. <br />
                                    작지만 새로운 파워. <br />
                                    어마무시한 가능성
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div className="viva-seven">
                <div className="img pc" style={{ backgroundImage: `url(${IMG_7_1})` }} />
                <div className="img mobile" style={{ backgroundImage: `url(${IMG_7_2})` }} />
                <div className="text-box">
                    <div className="sub">Ultra easy</div>
                    <div className="t1">더 쉽고 더&nbsp;완벽한</div>
                </div>
            </div>

            <div className="viva-eight">
                <div className="t1">
                    작지만 시선을 사로잡는 <br />
                    균형 잡힌 완벽함
                </div>
                <div className="swiper-outer">
                    <button className="slide-control-btn prev">
                        <img src={IMG_8_1} alt="" />
                    </button>
                    <button className="slide-control-btn next">
                        <img src={IMG_8_2} alt="" />
                    </button>
                    <ScooterVivaImgSwiper />
                </div>
            </div>

            <div className="viva-nine" style={{ backgroundImage: `url(${IMG_9_1})` }}>
                <div className="img" style={{ backgroundImage: `url(${IMG_9_2})` }} />
                <div className="text-box">
                    <div className="sub">Ultra attractive</div>
                    <div className="t1">
                        매력적이고 <br />
                        콤팩트한 디자인
                    </div>
                </div>
            </div>

            <div className="viva-ten">
                <div className="t1">
                    모두의 시선을 사로잡는 <br />
                    트렌디하고 콤팩트한 디자인
                </div>
                <div className="grid-box">
                    <div>
                        <div className="one img" style={{ backgroundImage: `url(${IMG_10_1})` }}>
                            <div className="text-box">
                                <div className="sub">캡슐형 헤드라이트</div>
                                <div className="t1">
                                    VIVA 패밀리 캡슐 디자인. <br />
                                    도시의 중심에서 <br />
                                    현대와 클래식 스타일을 <br />
                                    과감하게 믹스 앤 매치하십시오.
                                </div>
                            </div>
                        </div>
                    </div>
                    <div>
                        <div className="two img" style={{ backgroundImage: `url(${IMG_10_2})` }}>
                            <div className="text-box">
                                <div className="sub">가벼운 핸들</div>
                                <div className="t1">
                                    고정관념을 뛰어 넘은 <br />
                                    가볍고 매력적인 핸들은 <br />
                                    골목, 거리를 쉽고 편하게 <br />
                                    이동할 수 있습니다.
                                </div>
                            </div>
                        </div>
                    </div>
                    <div>
                        <div className="three img" style={{ backgroundImage: `url(${IMG_10_3})` }}>
                            <div className="text-box">
                                <div className="sub">미니멀리스트 페달</div>
                                <div className="t1">
                                    인체공학적 페달은 모든 <br />
                                    신체 유형에 적합하여 유연하게 <br />
                                    사용할 수 있는 공간을 제공합니다.
                                </div>
                            </div>
                        </div>
                    </div>
                    <div>
                        <div className="four img" style={{ backgroundImage: `url(${IMG_10_4})` }}>
                            <div className="text-box">
                                <div className="sub">선형 랜덤 테일라이트</div>
                                <div className="t1">
                                    어둠을 가르는 깨끗한 선. <br />
                                    길을 따라가는 눈, 당신을 <br />
                                    바라보는 것만으로도 충분합니다!
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div className="viva-eleven" style={{ backgroundImage: `url(${IMG_11_1})` }}>
                <div className="img" style={{ backgroundImage: `url(${IMG_11_2})` }} />
                <div className="text-box">
                    <div className="sub">Ultra smart</div>
                    <div className="t1">더 나은 삶 더 나은 주행</div>
                </div>
            </div>

            <div className="viva-twelve">
                <div className="t1">일상의 편리함을 더해주는 심플하고 세심한 설계</div>
                <div className="grid-box">
                    <div>
                        <div className="one img" style={{ backgroundImage: `url(${IMG_12_1})` }}>
                            <div className="text-box">
                                <div className="sub">통합 파워트레인</div>
                                <div className="t1">
                                    소프트 및 하드웨어가 사용되어 <br />
                                    모터 드라이브의 파형을 미세 조정하고 <br />
                                    펌웨어 최적화와 동기화를 통해 <br />
                                    매우 안정적이고 부드러운 이동을
                                    <br />
                                    구현합니다.
                                </div>
                            </div>
                        </div>
                    </div>
                    <div>
                        <div className="two img" style={{ backgroundImage: `url(${IMG_12_2})` }}>
                            <div className="text-box">
                                <div className="sub">느끼는대로 발송해드립니다</div>
                                <div className="t1">
                                    iQ System® 스마트 키 카드 * ,<br />
                                    탭하여 이동하고 즉시 도시의 <br />
                                    재미를 탐험하십시오.
                                </div>
                            </div>
                        </div>
                    </div>
                    <div>
                        <div className="three img" style={{ backgroundImage: `url(${IMG_12_3})` }}>
                            <div className="text-box">
                                <div className="sub">스마트, 커스텀</div>
                                <div className="t1">
                                    심지어... 음향 효과부터 <br />
                                    보안, 도난 방지까지 모든 것이 <br />
                                    당신의 개성에 따라 <br />
                                    설정될 수 있습니다!
                                </div>
                            </div>
                        </div>
                    </div>
                    <div>
                        <div className="four img" style={{ backgroundImage: `url(${IMG_12_4})` }}>
                            <div className="text-box">
                                <div className="sub">당신 차량에 대한 모든 것이 손 안에 있습니다.</div>
                                <div className="t1">
                                    Gogoro® 앱을 열고 가장 가까운 <br />
                                    GoStation® 배터리 교체 스테이션을 <br />
                                    찾거나 기본 차량 상태 진단을 <br />
                                    하거나 유지 보수를 예약하세요.
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div className="viva-thirteen" style={{ backgroundImage: `url(${IMG_13_1})` }}>
                <div className="title-box">
                    <img src={IMG_13_2} alt=""></img>
                    <div className="t1">스왑 앤 고</div>
                </div>
            </div>

            <div className="viva-fourteen" style={{ backgroundImage: `url(${IMG_14_1})` }}></div>

            <div className="viva-fifteen">
                <div className="viva-motors-wrapper">
                    <img src={IMG_15_1} alt="" />
                    <div className="t1">고고로 비바</div>
                    <div className="sub">열쇠가 없는</div>
                    <div className="colors">
                        <span style={{ backgroundColor: '#E1E124' }} />
                        <span style={{ backgroundColor: '#41447A' }} />
                        <span style={{ backgroundColor: '#DCDCDC' }} />
                        <span style={{ backgroundColor: '#FDCAD4' }} />
                    </div>
                </div>
                <div className="details">
                    <div className="t1">디테일</div>
                    <div className="details-box">
                        <div>
                            <div className="box-row">
                                <div className="s1">길이 x 너비 x 높이 (백미러 제외)</div>
                                <div className="d1">1,770 x 725 x 1,093mm</div>
                            </div>
                            <div className="box-row">
                                <div className="s1">휠베이스</div>
                                <div className="d1">1,235mm</div>
                            </div>
                            <div className="box-row">
                                <div className="s1">안장 높이</div>
                                <div className="d1">745mm</div>
                            </div>
                            <div className="box-row">
                                <div className="s1">무게 (비어 있음/배터리 포함)</div>
                                <div className="d1">94/112kg</div>
                            </div>
                        </div>
                        <div>
                            <div className="box-row">
                                <div className="s1">최대 전력</div>
                                <div className="d1">6.0kW @3,000rpm</div>
                            </div>
                            <div className="box-row">
                                <div className="s1">최대 토크 (모터/휠)</div>
                                <div className="d1">21 / 150Nm @ 0-2,500rpm</div>
                            </div>
                            <div className="box-row">
                                <div className="s1">등판성</div>
                                <div className="d1">
                                    30%(17°): 35km/h
                                    <br />
                                    20%(11°): 45km/h
                                    <br />
                                    10%(6°): 65km/h
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="extra-describes">
                        * 이 표는 참고용이며 테스트 시나리오에 따라 결과가 달라질 수 있습니다.
                        <br />* 자세한 정보는 고객센터를 통해 확인해주시기 바랍니다.
                    </div>
                </div>
            </div>
        </>
    )
}

export default ScooterViva
